import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=2963f788"
import script from "./radio.vue?vue&type=script&lang=js"
export * from "./radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2963f788')) {
      api.createRecord('2963f788', component.options)
    } else {
      api.reload('2963f788', component.options)
    }
    module.hot.accept("./radio.vue?vue&type=template&id=2963f788", function () {
      api.rerender('2963f788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sample/component/radio.vue"
export default component.exports